<template>
  <div class="c-collapse" :class="{ 'is-active': isActive }">
    <div class="c-collapse__header" @click.stop="toggle">
      <slot name="header"></slot>
      <i class="fas fa-angle-down"></i>
      <i class="fas fa-angle-up"></i>
    </div>
    <div class="c-collapse__content">
      <div class="c-collapse__inner" ref="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isActive: this.visible
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    }
  }
};
</script>
